import DragController from 'components/drag-controller/DragController';
import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
export default class SuggestionsList extends Component {
    constructor(el, options) {
        super(el, options);
    }
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            dragController: ['self', DragController]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            gradient: true
        };
    }
    bindEvents(add) {
        const method = bindMethod(add);
        this.refs.draggableItems.forEach((item) => {
            item[method]('mouseenter', (e) => this.onMouseEnter(e));
            item[method]('mouseleave', (e) => this.onMouseLeave(e));
        });
    }
    onMouseEnter = (e) => {
        const target = e.currentTarget;
        this.refs.draggableItems.forEach((item) => {
            item.classList.add('inactive');
        });
        target.classList.remove('inactive');
    };
    onMouseLeave = (e) => {
        this.refs.draggableItems.forEach((item) => {
            item.classList.remove('inactive');
        });
    };
}
